import { Col } from "react-bootstrap";

export const InstructionCard = ({icon, title, body}) => {

    return (
        <Col className="instruction-card">
            <div className="detail-header d-flex flex-row gap-15px align-items-center py-4px">
                <div className="detail-icon ms-1">
                    {icon}
                </div>
                <div className="detail-name body semibold">{title}</div>
            </div>
            <div>
                <p className="body regular mb-0">
                    {body}
                </p>
            </div>
        </Col>
    );
}